import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(250px, 780px);
  border: 2px solid #767373;
  justify-content: center;
  background-color: #cbcbcb;
`;

export const UsersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
`;

export const StyledWrapperCards = styled.div`
  /* TODO: Estilos que se repiten en otro wrapper, ver si se mueven a un style global */
  display: grid;
  grid-row-gap: 16px;
  @media screen and (min-width: 768px) {
    grid-row-gap: 32px;
  }
  /* cuando esto esta habilitado no se ven los organism_selector */
  /* position: relative; */

  && .CardBase--shaded {
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.14);
  }
  && .CardBase_content--no-padding > div {
    padding-right: 16px;
    padding-left: 16px;
    @media screen and (min-width: 768px) {
      padding-right: 32px;
      padding-left: 32px;
    }
  }
  & .CardBase > header {
    padding: 16px 16px;
    @media screen and (min-width: 768px) {
      padding: 20px 32px;
    }
  }
  & .CardBase--titles {
    row-gap: 4px;
  }
  & .CardBase--titles > h2 {
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
    @media screen and (min-width: 768px) {
      font-size: 24px;
      line-height: 30px;
    }
  }
  & .CardBase--titles > h4 {
    font-size: 14px;
    line-height: 20px;
  }
  & .CardBase p {
    font-size: 14px;
  }
  & .CardBase .title-content {
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
  }
  & .CardBase .subtitle-content {
    font-size: 14px;
    line-height: 20px;
  }
  & .CardBase .text-content {
    font-size: 14px;
    line-height: 22px;
  }

  /* TODO: Estilos que se repiten en otro wrapper, ver si se mueven a un style global */
  & .Autocomplete-selector {
    & label {
      font-size: 14px;
      font-weight: bold;
      color: #383638;
    }
    & .Autocomplete-input-wrapper input {
      font-size: 14px;
      color: #383638;
    }
    & .Autocomplete-list li {
      font-size: 14px;
      color: #383638;
    }
  }
  /* TODO: Fin estilos repetidos */
`;

export const Rut = styled.div`
  & > span:nth-child(1) {
    font-weight: bold;
    display: block;
  }
`;
export const StyledRut = styled.div`
  & > span:nth-child(1) {
    font-weight: bold;
    display: block;
  }
`;

export const StyledGridWrapper = styled.div`
  display: grid;
  grid-row-gap: 16px;
  @media screen and (min-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 20px;
  }
`;

export const StyledTextOffice = styled.div`
  .info-office-selected {
    color:#383838;
    font-size: 400;
    line-height: 20px;
    word-spacing: 0.2px;
    margin-left: -20px;
    margin-top: 30px;

    
  }

  .li-office-selected {
    list-style: none;
    position: relative;
    padding-left: 1.5em;
  }

  .li-office-selected::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0.4em;
    width: 8px;
    height: 8px;
    background-color: #007DB7;
    border-radius: 50%;
  }
`;

export const StyledIconOffice = styled.div`
   .img-map-vector {
     margin-left: -55px;
     margin-top: 35px;
   }

   .sucursal-map {
    font-size: 13px;
    line-height: 20px;
    font-weight: 400;
    color: #383838;
    display: inline-block;
    position: absolute;
    margin-top: 25px;
    margin-left: 15px;
   }

   .direction-map {
    font-weight: bold;
    font-size: 12px;
    color: #383838;
    margin-left: -10px;
    margin-top:-14px;
   }

   @media screen and (max-width: 768px) {
    .container-map-vector {
      margin-left: 30%;
    } 
  }
`;

export const StyledWrapperInput = styled.article`
  position: relative;
  & > div {
    & > label {
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 4px;
    }
    & > div:nth-of-type(1) {
      /* para deshabilitar el click en el div que llama a la lista desplegable de inputCounter */
      & div[role='button'] {
        pointer-events: none;
        & i {
          display: none;
        }
      }
      /* para deshabilitar el div con las opciones del inputCounter en el caso que se use tabulacion */
      & > div:nth-of-type(3) {
        display: none;
      }
      & input {
        color: #383838;
      }
    }

    & > div:nth-of-type(2) {
      margin-top: 4px;
    }
    /* para ocultar la flechita del seleccionable */
    /* & div > div:nth-child(1) i {
      display: none;
      pointer-events: none;
    } */
    /* para que el input text despues del +56 no tenga tanto padding-left */
    & div > div:nth-child(2) input {
      padding-left: calc(2rem + 27px);
    }
  }
`;

export default Wrapper;
